import type { TFunction } from 'i18next';

/**
 * Single-item title or a localized “N items selected” string for bulk,
 * matching the change-category dialog pattern.
 */
export const getItemDisplayLabelForCount = (
    rows: Array<{ title?: string; info?: { title?: string } }>,
    t: TFunction,
): string => {
    if (rows.length === 0) {
        return '';
    }

    if (rows.length > 1) {
        return t('propertyCatalogBulkCategoryItemsSelected', {
            count: rows.length,
        });
    }

    const first = rows[0];
    return first.title ?? first.info?.title ?? '';
};
